import {DataFetcher} from '@aboutyou/data-fetcher';
import React from 'react';
import {CoinsHistoryHeaderSkeleton} from './CoinsHistoryHeaderSkeleton';
import {CoinsHistoryHeaderView} from './CoinsHistoryHeaderView';
import {useCoinsHistoryHeader} from './hooks/useCoinsHistoryHeader';

export const CoinsHistoryHeader = () => {
  return (
    <DataFetcher
      request={useCoinsHistoryHeader()}
      Error={null}
      Loading={CoinsHistoryHeaderSkeleton}
      View={CoinsHistoryHeaderView}
    />
  );
};
